import { CommonModule } from '@angular/common'
import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { MatIconModule } from '@angular/material/icon'
import { NbTooltipModule } from '@nebular/theme'

const TAB_SIZE = 126
/**
 * Represents a list of event zones
 */
@Component({
  selector: 'ngx-zones-header',
  templateUrl: './zones-header.component.html',
  styleUrls: ['./zones-header.component.scss'],
  imports: [CommonModule, MatIconModule, NbTooltipModule]
})
export class ZonesHeaderComponent implements OnInit, AfterViewInit {
  /**
   * Event model
   */
  @Input()
  event

  /**
   * Current zone model
   */
  @Input()
  zone

  /**
   * List of zones
   */
  @Input()
  zones = []

  /**
   * Connection status
   */
  @Input()
  status

  /**
   * Zone changed event emitter
   */
  @Output()
  selectedZone: EventEmitter<any> = new EventEmitter()

  @Output()
  refreshRequested: EventEmitter<any> = new EventEmitter()

  /**
   * Flag to view previous arrow
   */
  isFirstZoneViewed: boolean

  /**
   * Flag to view next arrow
   */
  isLastZoneViewed: boolean

  /**
   * Show refresh button
   */
  showRefresh: boolean

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    // Initialize flags here instead of ngAfterViewInit
    this.isFirstZoneViewed = true
    this.isLastZoneViewed = false
    this.showRefresh = false
  }

  ngAfterViewInit(): void {
    const elements: HTMLCollection = document.getElementsByClassName('venue-list')
    const element: HTMLUListElement = elements.length ? (elements[0] as HTMLUListElement) : null
    if (!element) return

    if (element.scrollLeft >= element.scrollWidth - element.offsetWidth) {
      this.isLastZoneViewed = true
      this.cdr.detectChanges() // Explicitly trigger change detection
    }
  }

  /**
   * Emits the selected zone
   * @param item Zone
   */
  activeZone(item) {
    this.selectedZone.emit(item)
  }

  /**
   * Is the current zone the provided zone slug
   * @param slug string
   * @returns boolean
   */
  isZone(slug): boolean {
    return this.zone.slug === slug || this.zone === slug
  }

  /**
   * Pushes the zone list to the right
   * @returns void
   */
  showPreviousZone() {
    const elements: HTMLCollection = document.getElementsByClassName('venue-list')
    const element: HTMLUListElement = elements.length ? (elements[0] as HTMLUListElement) : null
    if (!element) return
    element.scrollLeft = element.scrollLeft - TAB_SIZE
    if (element.scrollLeft === 0) this.isFirstZoneViewed = true
    if (element.scrollLeft < element.scrollWidth - element.offsetWidth) this.isLastZoneViewed = false
    this.cdr.detectChanges() // Explicitly trigger change detection
  }

  /**
   * Pulls the zone list to the left
   * @returns void
   */
  showNextZone() {
    const elements: HTMLCollection = document.getElementsByClassName('venue-list')
    const element: HTMLUListElement = elements.length ? (elements[0] as HTMLUListElement) : null
    if (!element) return
    element.scrollLeft = element?.scrollLeft + TAB_SIZE
    if (element.scrollLeft > 0) this.isFirstZoneViewed = false
    if (element.scrollLeft >= element.scrollWidth - element.offsetWidth) this.isLastZoneViewed = true
    this.cdr.detectChanges() // Explicitly trigger change detection
  }

  onReconnectClicked() {
    this.status === false ? this.refreshRequested.emit() : ''
  }
}
